import { Customer } from '@/types/customer';
import { ChildStep } from '@/types/steps';

export const getStepSkipMessage = (
  step: ChildStep<unknown>,
  customer: Customer | undefined,
): string | undefined => {
  if (!step.skip) {
    return undefined;
  } else if (typeof step.skip === 'string') {
    return step.skip;
  } else if (typeof step.skip === 'function') {
    return step.skip(customer);
  } else {
    console.debug('Unknown skip type:', step.skip);
    return undefined;
  }
};
